import React from 'react';

export default function PrivacyPolicyPage() {
  return (
    <div style={{ maxWidth: 760, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', color: '#1a1a1a', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 4 }}>Privacy Policy</h1>
      <p style={{ color: '#888', fontSize: 14, marginBottom: 40 }}>Last updated: May 2026</p>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>What we collect</h2>
        <p>
          When you use the eYantra AI Assistant (available on ChatGPT and other AI platforms) to
          submit a quote request, we collect the information you provide: your name, email address,
          phone number (optional), company name, and the product selections and quantities included
          in your quote request.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>How we use it</h2>
        <p>
          This information is used solely to process your Request for Quote (RFQ) and for our sales
          team to follow up with a customised quotation. We do not use it for marketing without your
          consent.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Data storage</h2>
        <p>
          Your information is stored securely on eYantra's servers hosted on AWS in India. We retain
          quote data for up to 3 years for business records.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Third parties</h2>
        <p>
          We do not sell or share your personal information with third parties except where required
          by law.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>AI platforms</h2>
        <p>
          Our AI assistant is available through platforms such as ChatGPT (OpenAI). Your interactions
          with those platforms are also subject to their respective privacy policies. For ChatGPT,
          refer to{' '}
          <a href="https://openai.com/privacy" target="_blank" rel="noreferrer" style={{ color: '#E05010' }}>
            openai.com/privacy
          </a>.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Contact</h2>
        <p>
          For any privacy-related queries, contact us at{' '}
          <a href="mailto:tech@eyantra.com" style={{ color: '#E05010' }}>tech@eyantra.com</a> or write to:<br />
          eYantra, Hyderabad, India.
        </p>
      </section>
    </div>
  );
}